import { render, staticRenderFns } from "./HolidayInfo.vue?vue&type=template&id=53d66dc7"
import script from "./HolidayInfo.vue?vue&type=script&lang=js"
export * from "./HolidayInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports